import * as TYPES from './mutationTypes'

export default {
  updateChainCid(state, param) {
    state.chainCid = param
  },
  //交易
  [TYPES.GET_CA_LIST](state, payload) {
    const { limit, offset, total } = payload.result
    Object.assign(state, {
      ca_list: payload.result.items,
      ca_paging: { limit, offset, total }
    })
  }
}
